import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { IUserCrud } from "../interfaces/ilogin";
import { UserCountryTaskService } from "../services/usercountrytask.service";
import { Observable } from "rxjs";
import { IUserCountryTask } from "../interfaces/iusercountrytask";

@Injectable()
export class UserCountryTasksResolver implements Resolve<IUserCountryTask[]> {
    constructor(private userCountryTaskService: UserCountryTaskService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<IUserCountryTask[]> {
        return this.userCountryTaskService.getUserCountryTasks();
    }
}
